import { render } from "./EnderecoFields.vue?vue&type=template&id=0bc29639"
import script from "./EnderecoFields.vue?vue&type=script&lang=js"
export * from "./EnderecoFields.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__